<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/">
        <icon name="dashboard" class="mr-2 w-4 h-4"
              :class="isUrl('/dashboard') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
        <div :class="isUrl('/dashboard') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
          {{ $t('ui.home') }}
        </div>
      </Link>
    </div>

    <div class="mb-4" v-if="isAdmin">
      <Link class="group flex items-center py-3" :href="route('admin.users.index')">
        <icon name="users" class="mr-2 w-4 h-4"
              :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
        <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
          {{ $t('models.user') }}
        </div>
      </Link>
    </div>

    <div class="mb-4" v-if="isAdmin">
      <Link class="group flex items-center py-3" :href="route('admin.members.index')">
        <icon name="users" class="mr-2 w-4 h-4"
              :class="isUrl('members') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
        <div :class="isUrl('members') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
          {{ $t('models.member') }}
        </div>
      </Link>
    </div>

    <div class="mb-4">
      <Link class="group flex items-center py-3"
            :href="isAdmin ? route('admin.elections.index') : route('member.elections.index')">
        <icon name="users" class="mr-2 w-4 h-4"
              :class="isUrl('elections') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
        <div :class="isUrl('elections') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
          {{ $t('models.election') }}
        </div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  computed: {
    isAdmin() {
      return ['Superadmin', 'Admin'].includes(this.$page.props.auth.user.role_name);
    },
    isMember() {
      return ['Member'].includes(this.$page.props.auth.user.role_name);
    },
  },
  methods: {
    isUrl(...urls) {
      if (urls[0] === '') {
        return currentUrl === ''
      }
      let currentUrl = this.$page.url;
      const parts = this.$page.url.split('/');
      if (parts.length > 2) {
        currentUrl = this.$page.url.split('/')[2];
      }
      // console.log(urls, this.$page.url, parts, currentUrl);
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
